import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, SendIcon, CheckCircle2Icon, ExternalLinkIcon } from 'lucide-react';
export function ContactSection() {
  const [isSuccess, setIsSuccess] = useState(false);
  return <section id="kontakt" className="py-24 bg-neutral-900 text-neutral-300 relative overflow-hidden" data-id="element-24">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-[800px] h-[800px] bg-[#e0a812]/10 rounded-full blur-3xl pointer-events-none" data-id="element-25" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-26">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-27">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-28">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-29">
              Kontaktujte nás
            </h2>
            <p className="text-lg text-neutral-400 mb-12 max-w-md" data-id="element-30">
              Máte zájem o pronájem nebo se chcete dozvědět více? Neváhejte nás
              kontaktovat. Rádi s vámi probereme vaše požadavky.
            </p>

            <div className="space-y-8" data-id="element-31">
              <div className="flex items-center group ml-[20px] mr-[20px]" data-id="element-32">
                <div className="w-12 h-12 bg-neutral-800 rounded-sm flex items-center justify-center text-[#e0a812] group-hover:bg-[#e0a812] group-hover:text-white transition-colors" data-id="element-33">
                  <PhoneIcon className="w-6 h-6" data-id="element-34" />
                </div>
                <div className="ml-6" data-id="element-35">
                  <p className="text-sm text-neutral-500 font-medium uppercase tracking-wider" data-id="element-36">
                    Telefon
                  </p>
                  <a href="tel:+420777008930" className="text-xl font-semibold text-white hover:text-[#e0a812] transition-colors" data-id="element-37">
                    +420 777 008 930
                  </a>
                </div>
              </div>

              <div className="flex items-center group ml-[20px] mr-[20px]" data-id="element-38">
                <div className="w-12 h-12 bg-neutral-800 rounded-sm flex items-center justify-center text-[#e0a812] group-hover:bg-[#e0a812] group-hover:text-white transition-colors" data-id="element-39">
                  <MailIcon className="w-6 h-6" data-id="element-40" />
                </div>
                <div className="ml-6" data-id="element-41">
                  <p className="text-sm text-neutral-500 font-medium uppercase tracking-wider" data-id="element-42">
                    E-mail
                  </p>
                  <a href="mailto:info@tsmachine.cz" className="text-xl font-semibold text-white hover:text-[#e0a812] transition-colors" data-id="element-43">
                    info@tsmachine.cz
                  </a>
                </div>
              </div>

              <div className="flex items-center group ml-[20px] mr-[20px]" data-id="element-44">
                <div className="w-12 h-12 bg-neutral-800 rounded-sm flex items-center justify-center text-[#e0a812] group-hover:bg-[#e0a812] group-hover:text-white transition-colors" data-id="element-45">
                  <MapPinIcon className="w-6 h-6" data-id="element-46" />
                </div>
                <div className="ml-6" data-id="element-47">
                  <p className="text-sm text-neutral-500 font-medium uppercase tracking-wider" data-id="element-48">
                    Adresa
                  </p>
                  <p className="text-xl font-semibold text-white" data-id="element-49">
                    Žlutice, Karlovarský kraj
                  </p>
                </div>
              </div>

              {/* Map Link Card */}
              <a href="https://www.google.com/maps/dir//50.0868341,13.1622311/@50.0869142,13.1612436,262m/data=!3m1!1e3!4m2!4m1!3e0!18m1!1e1?entry=ttu&g_ep=EgoyMDI2MDMxNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="block group mt-4" data-id="element-50">
                <div className="relative overflow-hidden rounded-sm border border-neutral-700 bg-neutral-800 p-5 hover:border-[#e0a812]/50 transition-all duration-300" data-id="element-51">
                  {/* Decorative background pattern */}
                  <div className="absolute inset-0 opacity-[0.06]" data-id="element-52">
                    <svg className="w-full h-full" viewBox="0 0 300 120" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-53">
                      <path d="M0 30 Q75 15 150 35 T300 25" stroke="#e0a812" strokeWidth="1" data-id="element-54" />
                      <path d="M0 50 Q80 35 160 55 T300 45" stroke="#e0a812" strokeWidth="1" data-id="element-55" />
                      <path d="M0 70 Q70 55 140 75 T300 65" stroke="#e0a812" strokeWidth="1" data-id="element-56" />
                      <path d="M0 90 Q90 75 180 95 T300 85" stroke="#e0a812" strokeWidth="1" data-id="element-57" />
                      <path d="M0 110 Q60 95 120 115 T300 105" stroke="#e0a812" strokeWidth="1" data-id="element-58" />
                    </svg>
                  </div>

                  <div className="relative z-10 flex items-center justify-between" data-id="element-59">
                    <div className="flex items-center space-x-4" data-id="element-60">
                      <div className="w-12 h-12 bg-[#e0a812]/10 rounded-sm flex items-center justify-center border border-[#e0a812]/20 group-hover:bg-[#e0a812]/20 transition-colors" data-id="element-61">
                        <MapPinIcon className="w-6 h-6 text-[#e0a812]" data-id="element-62" />
                      </div>
                      <div data-id="element-63">
                        <p className="text-white font-semibold text-lg group-hover:text-[#e0a812] transition-colors" data-id="element-64">
                          Zobrazit na mapě
                        </p>
                        <p className="text-neutral-500 text-sm" data-id="element-65">
                          Žlutice — otevřít v Google Maps
                        </p>
                      </div>
                    </div>
                    <ExternalLinkIcon className="w-5 h-5 text-neutral-500 group-hover:text-[#e0a812] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" data-id="element-66" />
                  </div>
                </div>
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-neutral-800 p-8 rounded-sm shadow-2xl border border-neutral-700 relative" data-id="element-67">
            {isSuccess ? <div className="absolute inset-0 flex flex-col items-center justify-center bg-neutral-800 rounded-sm z-10 p-8 text-center" data-id="element-68">
                <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 200,
              damping: 20
            }} data-id="element-69">
                  <CheckCircle2Icon className="w-20 h-20 text-[#e0a812] mb-6 mx-auto" data-id="element-70" />
                </motion.div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-71">
                  Zpráva odeslána
                </h3>
                <p className="text-neutral-400" data-id="element-72">
                  Děkujeme za váš zájem. Brzy se vám ozveme zpět.
                </p>
              </div> : null}

            <form action="https://formsubmit.co/info@tsmachine.cz" method="POST" className="space-y-6" data-id="element-73">
              {/* FormSubmit configuration */}
              <input type="hidden" name="_cc" value="kasspi@gmail.com" data-id="element-74" />
              <input type="hidden" name="_subject" value="Nová poptávka z webu — Areál Žlutice" data-id="element-75" />
              <input type="hidden" name="_captcha" value="false" data-id="element-76" />
              <input type="hidden" name="_template" value="table" data-id="element-77" />
              <input type="text" name="_honey" style={{
              display: 'none'
            }} data-id="element-78" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-79">
                <div data-id="element-80">
                  <label htmlFor="name" className="block text-sm font-medium text-neutral-400 mb-2" data-id="element-81">
                    Jméno a příjmení
                  </label>
                  <input type="text" id="name" name="name" required className="w-full bg-neutral-900 border border-neutral-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#e0a812] focus:border-transparent transition-shadow" placeholder="Jan Novák" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <label htmlFor="phone" className="block text-sm font-medium text-neutral-400 mb-2" data-id="element-84">
                    Telefon
                  </label>
                  <input type="tel" id="phone" name="phone" className="w-full bg-neutral-900 border border-neutral-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#e0a812] focus:border-transparent transition-shadow" placeholder="+420 123 456 789" data-id="element-85" />
                </div>
              </div>

              <div data-id="element-86">
                <label htmlFor="email" className="block text-sm font-medium text-neutral-400 mb-2" data-id="element-87">
                  E-mail
                </label>
                <input type="email" id="email" name="email" required className="w-full bg-neutral-900 border border-neutral-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#e0a812] focus:border-transparent transition-shadow" placeholder="jan.novak@email.cz" data-id="element-88" />
              </div>

              <div data-id="element-89">
                <label htmlFor="message" className="block text-sm font-medium text-neutral-400 mb-2" data-id="element-90">
                  Zpráva
                </label>
                <textarea id="message" name="message" required rows={4} className="w-full bg-neutral-900 border border-neutral-700 rounded-sm px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#e0a812] focus:border-transparent transition-shadow resize-none" placeholder="Dobrý den, měl bych zájem o..." data-id="element-91"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#e0a812] hover:bg-[#c4920f] text-white font-medium py-4 px-6 rounded-sm transition-colors flex items-center justify-center" data-id="element-92">
                <span className="flex items-center" data-id="element-93">
                  Odeslat poptávku
                  <SendIcon className="ml-2 w-5 h-5" data-id="element-94" />
                </span>
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}